// Copyright (c) 2025 Annadaneshwar Yadawad. All rights reserved.

const API_BASE_URL = 'https://annadaneshwar-notification-service.azurewebsites.net/public/api/notifications';
let eventSource = null;

export function initEventSource() {
    if (!eventSource) {
        // Updated to use /subscribe endpoint
        eventSource = new EventSource(`${API_BASE_URL}/subscribe`);
    }
    return eventSource;
}

export function closeEventSource() {
    if (eventSource) {
        eventSource.close();
        eventSource = null;
    }
}

export async function subscribeToNotifications() {
    if (!('Notification' in window)) {
        throw new Error('This browser does not support notifications');
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
        throw new Error('Notification permission denied');
    }

    const response = await fetch(`${API_BASE_URL}/subscribe`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            userId: localStorage.getItem('userId') || 'anonymous'
        }),
    });

    if (!response.ok) {
        const error = await response.text();
        throw new Error(error || 'Failed to subscribe to notifications');
    }

    return response.json();
}

export async function publishNotification({ message, type }) {
    const isAdmin = localStorage.getItem('isAdmin') === 'true';
    if (!isAdmin) {
        throw new Error('Only admin users can publish notifications');
    }
    try {
        const response = await fetch('https://annadaneshwar-notification-service.azurewebsites.net/public/api/notifications/publish', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ message, type }),
        });
        if (!response.ok) {
            let errorText = await response.text();
            console.error('Notification API error:', errorText);
            throw new Error('Failed to publish notification: ' + errorText);
        }
        const result = await response.text();
        return result;
    } catch (error) {
        console.error('Error publishing notification:', error);
        throw error;
    }
}

export async function getSubscriberCount() {
    try {
        const response = await fetch(`${API_BASE_URL}/subscribers/count`);
        if (!response.ok) {
            throw new Error('Failed to fetch subscriber count');
        }

        const data = await response.json();

        // Handle both `{ count: 27 }` and plain `27`
        const count = typeof data === 'number' ? data : Number(data?.count);
        return Number.isFinite(count) ? count : 0;

    } catch (error) {
        console.error('Error fetching subscriber count:', error);
        return 0;
    }
}

